"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoonMineStandardProject = void 0;
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var StandardProjectCard_1 = require("../StandardProjectCard");
var MoonExpansion_1 = require("../../moon/MoonExpansion");
var PlaceMoonMineTile_1 = require("../../moon/PlaceMoonMineTile");
var Units_1 = require("../../Units");
var Resources_1 = require("../../Resources");
var TileType_1 = require("../../TileType");
var CardRenderItem_1 = require("../render/CardRenderItem");
var MoonMineStandardProject = (function (_super) {
    __extends(MoonMineStandardProject, _super);
    function MoonMineStandardProject() {
        var _this = _super.call(this, {
            name: CardName_1.CardName.MOON_MINE_STANDARD_PROJECT,
            cost: 20,
            metadata: {
                cardNumber: '',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    return b.standardProject('Spend 20 M€ and 1 titanium to place a mine on the moon, raise the Mining Rate 1 step, and raise steel production 1 step.', function (eb) {
                        eb.megacredits(20).titanium(1).startAction.moonMine().secondaryTag(CardRenderItem_1.AltSecondaryTag.MOON_MINING_RATE).production(function (pb) { return pb.steel(1); });
                    });
                }),
            },
        }) || this;
        _this.reserveUnits = Units_1.Units.of({ titanium: 1 });
        _this.tilesBuilt = [TileType_1.TileType.MOON_MINE];
        return _this;
    }
    MoonMineStandardProject.prototype.discount = function (player) {
        if (player.playedCards.find(function (card) { return card.name === CardName_1.CardName.MOONCRATE_BLOCK_FACTORY; })) {
            return 4;
        }
        return _super.prototype.discount.call(this, player);
    };
    MoonMineStandardProject.prototype.canAct = function (player) {
        var moonData = MoonExpansion_1.MoonExpansion.moonData(player.game);
        var spaces = moonData.moon.getAvailableSpacesForMine(player);
        if (spaces.length === 0) {
            return false;
        }
        return _super.prototype.canAct.call(this, player);
    };
    MoonMineStandardProject.prototype.actionEssence = function (player) {
        var adjustedReserveUnits = MoonExpansion_1.MoonExpansion.adjustedReserveCosts(player, this);
        player.deductUnits(adjustedReserveUnits);
        player.game.defer(new PlaceMoonMineTile_1.PlaceMoonMineTile(player));
        player.addProduction(Resources_1.Resources.STEEL, 1, { log: true });
    };
    return MoonMineStandardProject;
}(StandardProjectCard_1.StandardProjectCard));
exports.MoonMineStandardProject = MoonMineStandardProject;
//# sourceMappingURL=MoonMineStandardProject.js.map